import { ReactNode } from 'react'

export interface FeatureFlagProps {
  featureFlag: string
  children: JSX.Element
}

export const FeatureFlagWrapper = ({
  featureFlag,
  children,
}: FeatureFlagProps): ReactNode =>
  window.FEATURE_FLAGS.includes(featureFlag) ? children : null
